module.exports = __webpack_public_path__ + "static/media/pierre-5.2424dc17.jpeg";